<template>
    <div class="container-fluid container-fill">
        <div class="row">
            <div class="paper">
                <h2>
                    Permissions <!--<font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="AddRole(name,description)" class="olive-green-text pointer table-refresh client-list" />-->
                    <span class="AddModal">
                        <font-awesome-icon :icon="['fa', 'plus']" style="font-size: 24px;" class="pointer green " @click="ButtonClick" />

                        <b-modal @show="resetModal" @hidden="resetModal" ref="component-modal" title="Add Permission" hide-footer>
                            <b-container fluid>
                                <b-form @submit="AddPermission">
                                    <b-row no-gutters="true">
                                        <b-col cols="6">Permission Name:</b-col>
                                        <b-col cols="6" style="margin-bottom: 1rem"><b-form-input v-model="form.name" placeholder="Required" type="name" required></b-col>
                                    </b-row>
                                    <!--<b-row><p><br /></p></b-row>-->
                                    <b-row no-gutters="true">
                                        <b-col cols="6">Permission Description:</b-col>
                                        <b-col cols="6" style="margin-bottom: 1rem"><b-form-input v-model="form.description" placeholder="Required" type="name" required></b-col>
                                    </b-row>
                                    <b-row class="modal-btn-row">
                                        <div class="modal-btn-row-div">
                                            <b-button size="md" variant="secondary" @click="Cancel()">
                                                CANCEL
                                            </b-button>
                                            <b-button size="md" variant="primary" @click="submit">
                                                CONFIRM
                                            </b-button>
                                        </div>

                                    </b-row>
                                </b-form>
                            </b-container>
                        </b-modal>
                    </span>
                </h2>
                <vuetable :fields="ChildrenTableOptions.Fields"
                          :data="LoadedChildren"
                          pagination-path=""
                          :api-mode="false">

                    <template slot="PermissionActions" scope="props">
                        <div class="ChildRecordLinkFirst">
                            <font-awesome-icon :icon="['fa', 'edit']" class="pointer orange" style="font-size: 20px;" />
                            <ActionButtonWithIcon :requires-confirmation="true"
                                      confirmation-string="WARNING: You are about to delete this permission.  Are you sure?"
                                      endpoint="Admin/UserManagement/DeletePermission"
                                      :payload="{Id: props.rowData.Id}"
                                      :perform-global-update="false"
                                      button-variant="link"
                                      button-string=""
                                      button-size="md"
                                      emit-on-success="permission-deleted"
                                      v-on:success="RefreshDataTable"
                                      icon-prefix="fa"
                                      icon-suffix="trash-alt"
                                      icon-color="red"
                                      method="POST"/>
                        </div>
                    </template>
                    <!--<template slot="ChildRecordLinkLast" scope="props">
                        <div class="ChildRecordLinkLast">
                            <span class="underline pointer" @click="OpenChildRecord(props.rowData.ClientProgramMembership.Id, props.rowData)" v-html="props.rowData.Role.Description"></span>
                        </div>
                    </template>-->
                </vuetable>
            </div>
        </div>
    </div>
</template>

<script>
    //import services
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    // import helper functions
    import ActionButtonWithIcon from '../Admin/ActionButtonWithIcon.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faPencilAlt);
    export default {
        name: "ChildList",
        created() {
        },
        props: [],
        data: function () {
            return {
                CoreProgramSettingsList: [],
                form: {
                    name: '',
                    description: ''
                },
                name: '',
                description: '',
                TableSearch: "",
                Filters: {
                    ChildStatus: "Active",
                    SubProgramID: "",
                    CaseManagerID: ""
                },
                ChildrenTableOptions: {
                    Fields: [
                        {
                            name: 'Name',
                            title: 'Name'
                        },
                        {
                            name: 'Label',
                            title: 'Description'
                        },
                        {
                            name: 'Grouping',
                            title: 'Grouping'
                        },
                        {
                            name: 'DataType',
                            title: 'Data Type'
                        },
                        {
                            name: 'DefaultValue',
                            title: 'Default Value'
                        },
                        {
                            name: '__slot:PermissionActions',
                            title: 'Actions'
                        }
                    ]
                }
            };
        },
        methods: {
            resetModal() {
                this.name = '',
                    this.description = ''
            },
            ButtonClick() {
                this.ShowModal()
            },
            ShowModal() {
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            RefreshDataTable() {
                this.GetCoreProgramSettings();
            },
            AddPermission(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/AddPermission",
                    {
                        Name: this.form.name,
                        Description: this.form.description
                    }, 
                    this.AddPermissionSuccess, () => { }, true);

            },
            AddPermissionSuccess(response) {
                this.RefreshDataTable(); //get an error when i call this but still works
                this.Cancel();
            },
            GetCoreProgramSettings() {
                this.$MasterAPI.ExecuteRequest("Get", "Core/UserSettings/GetCoreProgamSettings", {}, this.GetCoreProgramSettingsSuccess, () => { }, false);

            },
            GetCoreProgramSettingsSuccess(response) {
                console.log(response.data)
                //this.$store.commit("Permissions.PermissionList.Replace", data.data);
                this.CoreProgramSettingsList = response.data.data;
            },
            //DeleteRole(roleID) {
            //    alert("This will delete role" + roleID);//replace with functionality
            //},
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OpenChildRecord(subProgramMembershipID, childRecordData) {
                //this.$store.commit("Permissions.PermissionList.Append", childRecordData);

                this.$parent.ChangePaneShown(subProgramMembershipID);
            },
            //getCurrentFamilyName(value) {
            //    let initList = value.filter(fam => fam.EndDate == null);
            //    if (initList.length == 1) {
            //        return initList[0].Name;
            //    } else {
            //        return null;
            //    }
            //},
            SortTable(sortOrder, pagination) {
                console.log(sortOrder);
                return { data: this.LoadedChildren };
            },
            //getCurrentCaseManagerName(value) {
            //    let initList = value.filter(cm => cm.EndDate == null);
            //    if (initList.length == 1) {
            //        return initList[0].Person.FullName;
            //    } else {
            //        return null;
            //    }
            //},
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            }
        },
        components: {
            Vuetable,
            ActionButtonWithIcon
        },
        computed: {
            LoadedChildren: function () {
                //if (this.TableSearch != "") {
                //    let vm = this;
                //    let results = []
                //    this.$store.state.Roles.RoleList.forEach(function (item) {
                //        let itemstring = JSON.stringify(item).toLowerCase();
                //        if (itemstring.includes(vm.TableSearch.toLowerCase())) {
                //            results.push(item);
                //        }
                //    });
                //    return results;
                //} else {
                //    return this.$store.state.Roles.RoleList;
                //}
                // gets the Client Enrollment List from the store
                return this.CoreProgramSettingsList;
            },
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            }
        },
        mounted() {
            this.Filters.SubProgramID = this.SubProgramOptions[0].value;
            var vm = this;
            //Get Child Records*/
            this.GetCoreProgramSettings();
            let getCoreProgramSettingsFunc = function () {
                vm.GetCoreProgramSettings();
            };
            this.$GlobalUpdate.AddGlobalUpdateFunction(getCoreProgramSettingsFunc);

        }
    }
</script>

<style scoped>
</style>